import React, { useState, useEffect } from "react";
import { Input, Col, Row, FormGroup, Label, Modal, Button, Table } from 'reactstrap';
import { Form, Field } from 'react-final-form';
import axios from 'axios';
import ReactTooltip from 'react-tooltip';

//CustomModules
import WYSIWYGEditor from '@/shared/components/form/WYSIWYGEditor'
import {useDispatch, flashError, flashSuccess} from "@/shared/components/flash"
import renderSelectField from '@/shared/components/form/Select'
import {getEventTypes} from '@/services/getEventTypes'
import {getEventTypeAccess} from '@/services/getEventTypeAccess'
import {getEventLedgerCodes, deleteSocialWallImage, fetchEventIcons} from '@/services/events'
import {labelizeNamedData, patch4Select, isBadgeAward, isCustomAward, isScheduledAwardEnabled,
isScheduledAwardRequired, isSaveToHierarchyEnabled,
amountToUsFormat, isMilestoneAward} from '@/shared/helpers'
import renderToggleButtonField from "@/shared/components/form/ToggleButton"
import formValidation from "@/validation/addEvent"
import TemplateButton from "@/shared/components/TemplateButton"
import Tabs from "./Tabs"
import SocialBgTabs from "./SocialBgTabs";
import { makeFormData } from './common'
import AwardLevelModal from './AwardLevelModal';
import {getEvent} from "@/services/program/getEvent";
import { 
  getEmailTemplate, 
  getEventEmailTemplate, 
  sendEventPreviewEmail, 
  sendEventTypePreviewEmail 
} from "@/services/program/getEmailTemplate";
import SaveHierarchyModal from "./SaveHierarchyModal";
import EmailTemplate from "./EmailTemplate";
import SelectProgramModal from "./SelectProgramModal";
import TrashIcon from "mdi-react/TrashCanIcon";
import { getMilestoneOptions } from "@/shared/apiHelper";

const EventForm = ({
  data,
  toggle,
  rootProgram,
  program,
  setTrigger
}) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false);
  const [eventTypes, setEventTypes] = useState([]);
  let [event, setEvent] = useState(null);
  const [ledgerCodes, setLedgerCodes] = useState([]);
  const [eventTypeId, setEventTypeId] = useState( null );
  const [programAwardLevels, setProgramAwardLevels] = useState( [] );
  const [awardModalOpen, setAwardModalOpen] = useState(false);
  const [programAwardLevel, sePprogramAwardLevel] = useState({});
  const [emailTemplate, setEmailTemplate] = useState(null);
  const [loadingTemplate, setLoadingTemplate] = useState(false);
  const [templateView, setTemplateView] = useState("web");
  const [milestoneOptions, setMilestoneOptions] = useState([]);
  const [hierarchyListData, setHierarchyListData] = useState([]);
  const [hierarchyListDataResult, setHierarchyListDataResult] = useState([]);
  const [isOpenHierarchy, setIsOpenHierarchy] = useState(false);
  const [isOpenHierarchyList, setOpenHierarchyList] = useState(false);
  const [isOpenHierarchyResult, setOpenHierarchyResult] = useState(false);
  const [checkedState, setCheckedState] = useState([]);

  useEffect(() => {
    const timeoutId = setTimeout(() => ReactTooltip.rebuild(), 0);
    return () => clearTimeout(timeoutId);
  });

  const toggleHierarchy = (values) => {
    setIsOpenHierarchy(prevState => !prevState)
  }

  const toggleHierarchyList = () => {
    const isHierarchyListOpen = isOpenHierarchyList;
    setOpenHierarchyList(prevState => !prevState)
    if(isHierarchyListOpen){ 
      toggleHierarchy();
    }
  }

  const toggleHierarchyResult = () => {
    const isOpen = isOpenHierarchyResult;
    setOpenHierarchyResult(prevState => !prevState);
    // Closing Event Form 
    if(isOpen){ 
      toggle(null, true)
    }
  }

  const onChangeEventType = (value) => {
    setEventTypeId(value.value);
  }

  const getListLedgerCodes = (program) => {
    getEventLedgerCodes(program.organization_id, program.id)
    .then(ledgercodes => {
      setLedgerCodes(labelizeNamedData(ledgercodes, ["id", "ledger_code"]))
    })
  }

    const getProgramAwardLevels = async () => {
        const response = await axios.get(
            `/organization/${data.organization_id}/program/${program.id}/program-award-levels`,
        );
        setProgramAwardLevels(response.data);
    };

    const createItems = async (fValue) => {
        const response = await axios.post(
            `/organization/${data.organization_id}/program/${program.id}/create-award-level`, fValue);
        if (response.data.success){
            // getDataItems();
            // setAction('index');
            // setAwardLevelName('');
        }
    };

  useEffect( () => {
    if( data?.id )
    {
      const iconObj = (typeof data.icon === 'object' && data.icon) || (typeof data.event_icon === 'object' && data.event_icon);
      if (data.event_icon_id && !iconObj && program?.organization_id) {
        fetchEventIcons(program, 'both').then(icons => {
          const matched = icons.find(i => String(i.id) === String(data.event_icon_id));
          console.log('[EventForm] fetchEventIcons matched:', matched);
          setEvent(matched ? { ...data, icon: matched, event_icon: matched } : data);
        }).catch(() => setEvent(data));
      } else {
        setEvent(data);
      }
      setEventTypeId(data.event_type_id);
        getProgramAwardLevels();
    }
    if (program?.allow_milestone_award) {
      getMilestoneOptions(program.organization_id, program.id).then((o) => {
        const formattedOptions = Object.entries(o).map(([key, value]) => ({
          value: parseInt(key),
          label: value,
        }));

        setMilestoneOptions(formattedOptions);
      });
    }
    if( program?.id ) {
      Promise.all([
        getEventTypes(program.organization_id, program.id),
        getEventTypeAccess(program.organization_id, program.id).catch(() => []),
      ]).then(([evtypes, accessSettings]) => {
        let filtered = Array.isArray(evtypes) ? evtypes : [];
        if (Array.isArray(accessSettings) && accessSettings.length > 0) {
          filtered = filtered.filter(et => {
            const setting = accessSettings.find(a => a.event_type_id === et.id);
            return setting == null || Boolean(setting.manager_access);
          });
        }
        setEventTypes(labelizeNamedData(filtered))
        setLoading(false)
      })
      getListLedgerCodes(program)
    }
  }, [data, program])

  const [isIconModalOpen, setIconModalOpen] = useState(false);
  const [isSocialWallBgModalOpen, setSocialWallBgModalOpen] = useState(false); 
  const [activeTab, setActiveTab] = useState('2');
  const [eventFormValues, setEventFormData] =  useState(null);
  
  const submitEvent = (values) => {
    let data = makeFormData(program, values)
    let url = `/organization/${program.organization_id}/program/${values.program_id ? values.program_id : program.id}/event`
    let method = 'post'

    if(event?.id) //Is Edit
    {
      url += `/${event.id}`
      method = 'put'
    }
    createOrUpdateEventApiCall(data, url, method);
  };

  const onSubmit = (values) => {
    if(isCustomAward( getActiveEventTypeId() )){
      values.award_message_editable = true;
    }

    if(event?.id && isSaveToHierarchyEnabled(rootProgram, program)){ // Show Hierarchy Dialog on update event, only if enabled
      setEventFormData(values);
      setIsOpenHierarchy(true);
    }else{
      submitEvent(values);
    }
  };

  const onSubmitOnlyProgram = () => {
    submitEvent(eventFormValues);
  };

  const onSubmitHierarchy = () => {
    let data = makeFormData(program, eventFormValues)
    let url = `/organization/${program.organization_id}/program/${eventFormValues.program_id ? eventFormValues.program_id : program.id}/event`
    let method = 'post'

    let isHierarchyData = false;
    if(event?.id) //Is Edit
    {
      url += `/${event.id}/hierarchy-prepare?excludeArchived=true`
      method = 'put';
      isHierarchyData = true;
    }
    createOrUpdateEventApiCall(data, url, method, isHierarchyData);
  };

  const createOrUpdateEventApiCall = (data, url, method, isHierarchy =false) => {
    setLoading(true)
    axios({ url, method, data })
    .then((res) => {
      if (res.status == 200) {
        if(isHierarchy){        
          const tmpCheckedState = [];
          res.data.map(item => {
            tmpCheckedState.push({checked: true, value: item.id});
          });
          setCheckedState(tmpCheckedState);
          setHierarchyListData(res.data);  
          toggleHierarchyList();
          setLoading(false);
        }else{
          flashSuccess(dispatch, 'Event saved successfully!')
          setLoading(false)
          toggle(null, true)
        }
        
      }
    })
    .catch((err) => {
      flashError(dispatch, err.response.data)
      setLoading(false)
    });
  }

  const toggleIconModal = () => {
    setIconModalOpen(prevState => !prevState)
  }

  const toggleSocialWallBgModal = () => {
    setSocialWallBgModalOpen(prevState => !prevState)
  }
  
  const setSocialWallPath = (icon) => {
    const path = process.env.REACT_APP_API_STORAGE_URL + "/" + icon?.path;
    return path;
  } 

  const setIconPath = (icon) => {
    if (!icon?.path) return null;
    return process.env.REACT_APP_API_STORAGE_URL + "/" + icon.path;
  }
  const onClickDeleteIcon = (icon) => {
    deleteSocialWallImage(program, icon)
      .then(response => {
        if (response.status === 200) {
          onClickEditEvent(event.id)
        }
      })
  }
  const onChangeAwardValue = ([field], state, { setIn, changeValue }) => {
    const v = field.target.value
    if( isNaN( v ) ) return;
    if(field.target.name === 'max_awardable_amount')
    {
      const field = state.fields["awarding_points"];
      field.change( program.factor_valuation *  v);
    }
    else if(field.target.name === 'awarding_points')
    {
      const field = state.fields["max_awardable_amount"];
      field.change(v / program.factor_valuation);
    }
  }

  const setEventIcon = ([fieldName, fieldVal], state, {changeValue }) => {

    /**
     * fieldVal = {id: 46, organization_id: 0, name: 'Goal', path: 'eventIcons/default/2.jpg'}
     */

    if(!event?.id)
    {
      // // The fields changed in fields in above resets after closing the modal. I think this is related to Two modal opened, one after another or something??
      changeValue(state, 'event_icon_id', () => fieldVal.id);
      changeValue(state, fieldName, () => fieldVal);
    } else  {
      let newEvent = {...event, ...{'event_icon_id': fieldVal.id, [fieldName]: fieldVal}}
      setEvent(newEvent)
    }

    setIconModalOpen(false);
  }

  const setSocaiWallBgImage = ([fieldName, fieldVal], state, {changeValue }) => {
    if(!event?.id)
    {
      // // The fields changed in fields in above resets after closing the modal. I think this is related to Two modal opened, one after another or something??
      changeValue(state, 'social_wall_image_id', () => fieldVal.id);
      changeValue(state, fieldName, () => fieldVal);
    } else  {
      let newEvent = {...event, ...{'social_wall_image_id': fieldVal.id, [fieldName]: fieldVal}}
      setEvent(newEvent)
    }

    setSocialWallBgModalOpen(false);
  }

  const getActiveEventTypeId = () => {
    if( eventTypeId ) return eventTypeId
    if( event && event?.event_type_id) return event.event_type_id
  }

  if( loading ) return (
    <div className="event-form__loading">
      <div className="event-form__loading-spinner" />
      <span>Saving event…</span>
    </div>
  )

  if (event && event?.id) {
    event = patch4Select(event, 'event_type_id', eventTypes)
    event = patch4Select(event, 'ledger_code', ledgerCodes)
    event = patch4Select(event, 'milestone_award_frequency', milestoneOptions)
    event.icon = (typeof event?.icon === 'object' && event.icon) ? event.icon : event.event_icon
    if (event?.max_awardable_amount) {
      event.awarding_points = program.factor_valuation * event.max_awardable_amount
    }
  }
    const handleDeleteAwardLevel = (award) => {
        axios.delete(`/organization/${program.organization_id}/program/${program.id}/event-award-level/${award.id}`, {data:award})
            .then((res) => {
                onClickEditEvent(event.id)
            }).catch((err) => {
        });
    };

    const handleAddAwardLevel = (award) => {
        sePprogramAwardLevel(award);
        setAwardModalOpen(true);
    };
    const handleAssignAwardLevel = () => {
        getProgramAwardLevels();
        onClickEditEvent(event.id)
        setAwardModalOpen(false);
    };

    const onClickEditEvent = (eventId) => {
        getEvent(program.organization_id, program.id, eventId).then((item) => {
            setEvent(item);
        });
    };
    

  const handlePreview = () => {
    setLoadingTemplate(true)

    if(event){
      setLoadingTemplate(true)
      getEventEmailTemplate(program.organization_id, program.id, event.id).then((data) => {
        setEmailTemplate(data.html);
        setLoadingTemplate(false)
      }).catch((err)=>{
        console.log("err",err);
        setLoadingTemplate(false)
      });
    }else{
      if (program && eventTypeId) {
        setLoadingTemplate(true)
        getEmailTemplate(program.organization_id, program.id, eventTypeId).then((data) => {
          setEmailTemplate(data.html);
          setLoadingTemplate(false)
        }).catch((err)=>{
          console.log("err",err);
          setLoadingTemplate(false)
        });
      }
    }
  };

  const sendPreviewEmail = () => {
    if(event){
      sendEventPreviewEmail(program.organization_id, program.id, event.id).then((data) => {
        console.log(data);
      }).catch((err)=>{
        console.log("err",err);
        setLoadingTemplate(false)
      });
    }else{
      if (program && eventTypeId) {
        sendEventTypePreviewEmail(program.organization_id, program.id, eventTypeId).then((data) => {
          console.log(data);
        }).catch((err)=>{
          console.log("err",err);
        });
      }
    }
  };

  const hidePreview = () => {
    setEmailTemplate(null)
  };

  const removeSocialWalImage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (window.confirm("Are you sure to delete Social Wall Background Image?")) {
      if(event && event.id){
        axios.delete(`/organization/${program.organization_id}/program/${program.id}/event/${event.id}/social-wall-image`, {})
          .then((res) => {
            flashSuccess(dispatch, 'Image deleted successfully!')
            setEvent({ ...event, social_wall_image_id: null, social_wall_image: null });
          }).catch((err) => {
            flashError(dispatch, err.response.data)
          });
      }else{
        setEvent({ ...event, social_wall_image_id: null, social_wall_image: null });
      }
    }
  }

  const onSubmitHierarchyList = () => {
    const eventData = makeFormData(program, eventFormValues)
    //eventData.icon = v2icon;
    const programIds = [];
    checkedState.map(item => {
      if(item.checked){
        programIds.push(item.value)
      }
    });
    eventData.programIds = programIds;

    axios
      .put(`/organization/${program.organization_id}/program/${program.id}/event/${event.id}/hierarchy?excludeArchived=true`, eventData)
      .then((res) => {
        if (res.status == 200) {
          setHierarchyListDataResult(res.data);
          setLoading(false);
          toggleHierarchyResult();
          toggleHierarchyList();
          flashSuccess(dispatch, 'Event saved successfully!')
        }
      })
      .catch((err) => {
        flashError(dispatch, err.response.data)
        setLoading(false);
        toggleHierarchyList();
      });
  };

  return (<>
    <Form
      keepDirtyOnReinitialize
      mutators={{
        onChangeAwardValue,
        setEventIcon, 
        setSocaiWallBgImage
      }}
      onSubmit={onSubmit}
      validate={(values) => formValidation.validateForm(values)}
      initialValues={event}
    >
      {({ handleSubmit, form, submitting, pristine, values }) => {
        const selectedEventType = eventTypes.find(
          (et) => et.value == getActiveEventTypeId(),
        );
        // console.log(values.icon)
        const activeEventTypeDesc = eventTypes && eventTypeId
          ? eventTypes.find(et => et.value === eventTypeId)?.description
          : null;
        const showAwardFields = !isBadgeAward(getActiveEventTypeId()) && !isCustomAward(getActiveEventTypeId());

        return (
          <form className="event-form" onSubmit={handleSubmit}>

            {/* ── Section 1: Configuration ── */}
            <div className="event-form__section">
              <div className="event-form__section-head">
                <span className="event-form__section-eyebrow">Configuration</span>
                <h4 className="event-form__section-title">Event Details</h4>
              </div>
              <div className="event-form__section-body">
                <div className="event-form__field event-form__field--full" data-tip="Determines the available award type and behavior for this event">
                  <label className="event-form__label">Event Type</label>
                  <Field
                    name="event_type_id"
                    className="react-select"
                    options={eventTypes}
                    placeholder="Select event type…"
                    component={renderSelectField}
                    parse={value => { onChangeEventType(value); return value; }}
                  />
                  {activeEventTypeDesc && (
                    <p className="event-form__type-hint">{activeEventTypeDesc}</p>
                  )}
                </div>
                <div className="event-form__grid">
                  <div className="event-form__field">
                    <label className="event-form__label">Event Name <span className="event-form__required">*</span></label>
                    <Field name="name">
                      {({ input, meta }) => (
                        <>
                          <Input className="event-form__input" placeholder="e.g. Q3 Sales Award" type="text" {...input} />
                          {meta.touched && meta.error && <span className="event-form__error">{meta.error}</span>}
                        </>
                      )}
                    </Field>
                  </div>
                  <div className="event-form__field" data-tip="Accounting code used to categorize this award for ledger reporting">
                    <label className="event-form__label">Ledger Code</label>
                    <Field
                      name="ledger_code"
                      className="react-select"
                      options={ledgerCodes}
                      isClearable={true}
                      component={renderSelectField}
                      placeholder="Select…"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* ── Section 2: Award Settings ── */}
            {showAwardFields && (
              <div className="event-form__section">
                <div className="event-form__section-head">
                  <span className="event-form__section-eyebrow">Award</span>
                  <h4 className="event-form__section-title">Award Settings</h4>
                </div>
                <div className="event-form__section-body">
                  <div className="event-form__grid">
                    <div className="event-form__field" data-tip="Maximum dollar amount that can be awarded per recipient for this event">
                      <label className="event-form__label">Max Awardable Amount</label>
                      <Field name="max_awardable_amount">
                        {({ input, meta }) => (
                          <>
                            <div className="event-form__amount-wrap max_awardable_amount">
                              <span className="event-form__amount-prefix">$</span>
                              <Input
                                className="event-form__amount-input"
                                placeholder="0.00"
                                type="text"
                                onKeyUp={form.mutators.onChangeAwardValue}
                                {...input}
                              />
                            </div>
                            {meta.touched && meta.error && <span className="event-form__error">{meta.error}</span>}
                          </>
                        )}
                      </Field>
                    </div>
                    <div className="event-form__field" data-tip="Points equivalent of the awarded amount, calculated automatically">
                      <label className="event-form__label">Awarding Points</label>
                      <Field name="awarding_points">
                        {({ input, meta }) => (
                          <>
                            <Input className="event-form__input" placeholder="0" type="text" onKeyUp={form.mutators.onChangeAwardValue} {...input} />
                            {meta.touched && meta.error && <span className="event-form__error">{meta.error}</span>}
                          </>
                        )}
                      </Field>
                    </div>
                  </div>
                  {isMilestoneAward(selectedEventType?.label) && (
                    <div className="event-form__field" style={{ maxWidth: '50%' }} data-tip="Year milestone interval used for milestone-based awards">
                      <label className="event-form__label">Milestone Year</label>
                      <Field
                        name="milestone_award_frequency"
                        className="react-select"
                        options={milestoneOptions}
                        component={renderSelectField}
                        placeholder="Select year…"
                      />
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* ── Section 3: Media ── */}
            <div className="event-form__section">
              <div className="event-form__section-head">
                <span className="event-form__section-eyebrow">Media</span>
                <h4 className="event-form__section-title">Icons &amp; Images</h4>
              </div>
              <div className="event-form__section-body">
                <div className="event-form__field" data-tip="Icon displayed for this award event">
                  <label className="event-form__label">Event Icon</label>
                  <button
                    type="button"
                    className="event-form__picker"
                    onClick={() => setIconModalOpen(true)}
                  >
                    {values.event_icon_id ? (
                      <>
                        {(() => {
                          const displayIcon = (typeof values.icon === 'object' && values.icon) || (typeof event?.icon === 'object' && event.icon) || event?.event_icon;
                          const displayName = displayIcon?.name
                            ? displayIcon.name.replace(/\.[^/.]+$/, '').split('/').pop()
                            : null;
                          return (<>
                            <img className="event-form__picker-preview" src={setIconPath(displayIcon)} alt={displayName} />
                            {displayName && <span className="event-form__picker-name">{displayName}</span>}
                          </>);
                        })()}
                        <span className="event-form__picker-action">Change</span>
                      </>
                    ) : (
                      <span className="event-form__picker-empty">+ Choose an icon</span>
                    )}
                  </button>
                  <Field name="event_icon_id">
                    {({ input, meta }) => (
                      <>
                        <input type="hidden" {...input} />
                        {meta.touched && meta.error && <span className="event-form__error">{meta.error}</span>}
                      </>
                    )}
                  </Field>
                </div>

                {program.uses_social_wall > 0 && (
                  <div className="event-form__field" data-tip="Background image shown for this event on the Social Wall">
                    <label className="event-form__label">Social Wall Background</label>
                    <button
                      type="button"
                      className="event-form__picker"
                      onClick={() => setSocialWallBgModalOpen(true)}
                    >
                      {values.social_wall_image ? (
                        <>
                          <img className="event-form__picker-preview event-form__picker-preview--wide" src={setSocialWallPath(values.social_wall_image)} alt={values.social_wall_image.name} />
                          <span className="event-form__picker-name">{values.social_wall_image.name}</span>
                          <span className="event-form__picker-action">Change</span>
                          <button
                            type="button"
                            className="event-form__picker-remove"
                            onClick={removeSocialWalImage}
                            aria-label="Remove image"
                          >
                            <TrashIcon size={14} />
                          </button>
                        </>
                      ) : (
                        <span className="event-form__picker-empty">+ Choose a background</span>
                      )}
                    </button>
                    <Field name="social_wall_image_id">
                      {({ input, meta }) => (
                        <>
                          <input type="hidden" {...input} />
                          {meta.touched && meta.error && <span className="event-form__error">{meta.error}</span>}
                        </>
                      )}
                    </Field>
                  </div>
                )}
              </div>
            </div>

            {/* ── Section 4: Settings ── */}
            <div className="event-form__section">
              <div className="event-form__section-head">
                <span className="event-form__section-eyebrow">Settings</span>
                <h4 className="event-form__section-title">Event Options</h4>
              </div>
              <div className="event-form__section-body event-form__section-body--toggles">
                <div className="event-form__toggle-row">
                  <div className="event-form__toggle-copy">
                    <span className="event-form__toggle-label">Enable This Event</span>
                    <span className="event-form__toggle-hint">Make this event active and available for awarding.</span>
                  </div>
                  <Field name="enable" component={renderToggleButtonField} />
                </div>
                {program.uses_social_wall > 0 && (
                  <div className="event-form__toggle-row">
                    <div className="event-form__toggle-copy">
                      <span className="event-form__toggle-label">Post to Social Wall</span>
                      <span className="event-form__toggle-hint">Share award activity on the social wall.</span>
                    </div>
                    <Field name="post_to_social_wall" component={renderToggleButtonField} />
                  </div>
                )}
                {(rootProgram.use_cascading_approvals > 0 || rootProgram.use_budget_cascading > 0) && (
                  <div className="event-form__toggle-row">
                    <div className="event-form__toggle-copy">
                      <span className="event-form__toggle-label">Include in Budget</span>
                      <span className="event-form__toggle-hint">Count awards from this event against the program budget.</span>
                    </div>
                    <Field name="include_in_budget" component={renderToggleButtonField} />
                  </div>
                )}
                {isScheduledAwardEnabled(rootProgram, program, event) && (
                  <div className={`event-form__toggle-row${rootProgram.schedule_awards_required ? ' d-none' : ''}`}>
                    <div className="event-form__toggle-copy">
                      <span className="event-form__toggle-label">Enable Scheduled Awards</span>
                      <span className="event-form__toggle-hint">Allow awards to be scheduled for a future date.</span>
                    </div>
                    <Field name="enable_schedule_award" component={renderToggleButtonField} />
                  </div>
                )}
                {!isCustomAward(getActiveEventTypeId()) && (
                  <div className="event-form__toggle-row">
                    <div className="event-form__toggle-copy">
                      <span className="event-form__toggle-label">Award Message Editable</span>
                      <span className="event-form__toggle-hint">Let managers customize the award message per recipient.</span>
                    </div>
                    <Field name="award_message_editable" component={renderToggleButtonField} />
                  </div>
                )}
              </div>
            </div>

            {/* ── Section 5: Award Message ── */}
            <div className="event-form__section">
              <div className="event-form__section-head">
                <span className="event-form__section-eyebrow">Content</span>
                <h4 className="event-form__section-title">Award Message</h4>
              </div>
              <div className="event-form__section-body">
                <div className="event-form__field event-form__field--full">
                  <Field name="message">
                    {({ input, meta }) => (
                      <>
                        <WYSIWYGEditor
                          name={input.name}
                          value={input.value}
                          onChange={input.onChange}
                          onBlur={input.onBlur}
                          placeholder="Write the award message recipients will see…"
                        />
                        {meta.touched && meta.error && <span className="event-form__error">{meta.error}</span>}
                      </>
                    )}
                  </Field>
                </div>
                <EmailTemplate
                  hidePreview={hidePreview}
                  handlePreview={handlePreview}
                  emailTemplate={emailTemplate}
                  loadingTemplate={loadingTemplate}
                  program={program}
                  eventTypeId={eventTypeId}
                  event={event}
                  sendPreviewEmail={sendPreviewEmail}
                />
              </div>
            </div>

            {/* ── Section 6: Award Levels (conditional) ── */}
            {Boolean(program?.use_award_levels) && (
              <div className="event-form__section">
                <div className="event-form__section-head">
                  <span className="event-form__section-eyebrow">Levels</span>
                  <h4 className="event-form__section-title">Award Levels</h4>
                </div>
                <div className="event-form__section-body">
                  {event?.eventAwardsLevel?.length > 0 && (
                    <div className="event-form__award-table-shell">
                      <table className="event-form__award-table">
                        <thead>
                          <tr>
                            <th data-tip="Name of the assigned award level">Name</th>
                            <th data-tip="Identifier of the award level">Level ID</th>
                            <th data-tip="Award amount for this level">Amount</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {event.eventAwardsLevel.map((award, index) => (
                            <tr key={index}>
                              <td>{award.name}</td>
                              <td>{award.award_level_id}</td>
                              <td>{award.amount}</td>
                              <td>
                                <button
                                  type="button"
                                  className="event-form__table-btn event-form__table-btn--danger"
                                  onClick={() => handleDeleteAwardLevel(award)}
                                >
                                  Remove
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}

                  <AwardLevelModal
                    isOpen={awardModalOpen}
                    toggle={() => setAwardModalOpen(false)}
                    awardLevel={programAwardLevel}
                    eventId={event?.id}
                    handleAssign={handleAssignAwardLevel}
                    organizationId={data?.organization_id}
                    programId={program.id}
                  />

                  {programAwardLevels.length > 0 && (
                    <>
                      <p className="event-form__award-assign-label">Available levels — click to assign:</p>
                      <div className="event-form__award-table-shell">
                        <table className="event-form__award-table">
                          <tbody>
                            {programAwardLevels.map((award, index) => (
                              <tr key={index}>
                                <td>{award.name}</td>
                                <td>
                                  <button
                                    type="button"
                                    className="event-form__table-btn event-form__table-btn--primary"
                                    onClick={() => handleAddAwardLevel(award)}
                                  >
                                    Assign
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}

            <div className="event-form__footer">
              <TemplateButton disabled={loading} type="submit" text="Save Event" />
            </div>
            <Modal
              className="manager-program-settings-dialog modal-program-events-icons modal-lg ltr-support"
              isOpen={isIconModalOpen}
              toggle={toggleIconModal}
              centered
            >
              <div className="manager-program-settings-dialog__header">
                <div className="manager-program-settings-dialog__header-copy">
                  <h4 className="manager-program-settings-dialog__title">Choose icon</h4>
                  <p className="manager-program-settings-dialog__description">
                    Upload a new icon or select one from the library.
                  </p>
                </div>
                <button
                  type="button"
                  className="manager-program-settings-dialog__close"
                  onClick={toggleIconModal}
                  aria-label="Close"
                >
                  Close
                </button>
              </div>
              <div className="manager-program-settings-dialog__body manager-program-settings-dialog__body--picker">
                <Tabs
                  onSelectIconOK={form.mutators.setEventIcon}
                  activeTab={activeTab}
                  onCancel={() => setIconModalOpen(false)}
                  icon={values?.icon ? values.icon : values.event_icon}
                />
              </div>
            </Modal>

            <Modal
              className="manager-program-settings-dialog modal-program-events-icons modal-lg ltr-support"
              isOpen={isSocialWallBgModalOpen}
              toggle={toggleSocialWallBgModal}
              centered
            >
              <div className="manager-program-settings-dialog__header">
                <div className="manager-program-settings-dialog__header-copy">
                  <h4 className="manager-program-settings-dialog__title">Choose background</h4>
                  <p className="manager-program-settings-dialog__description">
                    Upload a background image or choose one from the library.
                  </p>
                </div>
                <button
                  type="button"
                  className="manager-program-settings-dialog__close"
                  onClick={toggleSocialWallBgModal}
                  aria-label="Close"
                >
                  Close
                </button>
              </div>
              <div className="manager-program-settings-dialog__body manager-program-settings-dialog__body--picker">
                <SocialBgTabs
                  onSelectIconOK={form.mutators.setSocaiWallBgImage}
                  activeTab={activeTab}
                  onCancel={() => setSocialWallBgModalOpen(false)}
                  socialWallImg={values?.social_wall_bg ? values.social_wall_bg : values.event_icon}
                />
              </div>
            </Modal>
          </form>
        )
      }
      }
    </Form>

    <SaveHierarchyModal 
      isOpenHierarchy={isOpenHierarchy} 
      toggleHierarchy={toggleHierarchy}
      onSubmitOnlyProgram={onSubmitOnlyProgram}
      onSubmitHierarchy={onSubmitHierarchy}
    />

    <SelectProgramModal 
      toggleHierarchyList={toggleHierarchyList}
      onSubmitHierarchyList={onSubmitHierarchyList}
      toggleHierarchyResult={toggleHierarchyResult}
      setCheckedState={setCheckedState}
      isOpenHierarchyList={isOpenHierarchyList}
      hierarchyListData={hierarchyListData}
      checkedState={checkedState}
      programId={program?.id}
      isOpenHierarchyResult={isOpenHierarchyResult}
      hierarchyListDataResult={hierarchyListDataResult}
    />
  </>
  )
}

export default EventForm;
